// application/factories/modalSummaryPresenter.factory.ts
import { DpdSummaryPresenter, ThirdPartyModalSummaryPresenter, WebsitesSummaryPresenter } from '../../components/pages/Forms/PDD/summaryPresenters';
const summaryPresenters = {
    dpd: DpdSummaryPresenter,
    webs: WebsitesSummaryPresenter,
    thirdParty: ThirdPartyModalSummaryPresenter,
};
export const getModalSummaryPresenter = (key) => {
    var _a;
    if (!key)
        return null;
    return (_a = summaryPresenters[key]) !== null && _a !== void 0 ? _a : null;
};
